<template>
  <v-row justify="center">
    <v-dialog
      style="border-radius: 5px"
      v-model="show"
      persistent
      max-width="600px"
    >
      <custom-modal
        title="Create Expense "
        @onSubmit="SaveCategory"
        @onClose="close"
        :isLoading="isLoading"
      >
        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <v-row>
            <v-col cols="8" sm="8" lg="8">
              <v-radio-group v-model="Expense.type" row>
                <v-radio label="Warehouse" value="Warehouse"></v-radio>
                <v-radio label="Room" value="room"></v-radio>
                <v-radio label="Kitchen" value="kitchen"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="4" sm="4" lg="4">
              <ValidationProvider rules="required" name="Datetime">
                <datePickComponent
                  hide-details="auto"
                  slot-scope="{ errors }"
                  v-model="Expense.date"
                  labelname="Date"
                  :error-messages="errors"
                  required
                  :min="today"
                />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" lg="12">
              <ValidationProvider
                name="Expense For"
                rules="required"
                hide-details="auto"
              >
                <v-autocomplete
                  slot-scope="{ errors }"
                  outlined
                  hide-details="auto"
                  v-model="Expense.category_id"
                  item-text="name"
                  item-value="id"
                  :items="expenseCategories"
                  :search-input.sync="searchExpense"
                  :loading="expenseLoading"
                  :error-messages="errors"
                  label="Expense For"
                  required
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" v-if="Expense.type == 'Warehouse'">
              <ValidationProvider rules="required" name="warehouse">
                <v-autocomplete
                  outlined
                  slot-scope="{ errors }"
                  hide-details="auto"
                  v-model="Expense.wareHouse_id"
                  item-text="name"
                  item-value="id"
                  :items="warehouses"
                  :search-input.sync="searchWarehouse"
                  :loading="warehouseLoading"
                  :error-messages="errors"
                  label="Warehouse"
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col cols="6" v-if="Expense.type == 'room'">
              <ValidationProvider rules="required" name="Room">
                <v-autocomplete
                  outlined
                  slot-scope="{ errors }"
                  hide-details="auto"
                  v-model="Expense.room_id"
                  item-text="name"
                  item-value="id"
                  :items="rooms"
                  :search-input.sync="searchRoom"
                  :loading="roomLoading"
                  :error-messages="errors"
                  label="Room"
                  required
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col cols="6" v-if="Expense.type == 'kitchen'">
              <ValidationProvider rules="required" name="kitchen">
                <v-autocomplete
                  outlined
                  slot-scope="{ errors }"
                  hide-details="auto"
                  v-model="Expense.kitchen_id"
                  item-text="name"
                  item-value="id"
                  :items="kitchens"
                  :search-input.sync="searchKitchen"
                  :loading="kitchenLoading"
                  :error-messages="errors"
                  label="Kitchen"
                  required
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col cols="6" sm="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="Amount"
                rules="required"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="Expense.amount"
                  label="Amount"
                  auto-grow
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <!-- <ValidationProvider
                name="Remark"
                v-slot="{ errors }"
                hide-details="auto"
              > -->
                <v-textarea
                  hide-details="auto"
                  label="Remark"
                  v-model="Expense.remark"
                  outlined
                  rows="3"
                ></v-textarea>
              <!-- </ValidationProvider> -->
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <FileUpload
                :multiple="true"
                size="10000"
                v-model="selectedFiles"
                showList="true"
                ref="fileUpload"
                showPreview
              />
            </v-col>
          </v-row>
        </ValidationObserver>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>

import { mapState } from "vuex";
import datePickComponent from "../../../components/base/DateComponent";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import FileUpload from "@/components/base/FileUpload";
import CustomModal from "@/components/base/CustomModal";

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { Expenses } from "@/models/Expenses";
export default {
  data: () => ({
    selectedImages: "",
    selectedFiles: "",
    dialog: false,
    warehouses: [],
    searchWarehouse: null,
    expenseLoading: false,
    expenseCategories: [],

    ParentProductCategories: [],
    value: [],
    rooms: [],
    kitchens: [],
    options: [],
    isLoading: false,
  }),

  name: "AddCategory",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    expenseCategory: {
      type: Object,
      default: {},
    },
    Expense: {
      type: Object,
      default: {},
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    FileUpload,
    datePickComponent,
    CustomModal,
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close", this.expenseCategory);
        }
      },
    },
     today() {
      // Returns date in YYYY-MM-DD format that v-date-picker expects
      return new Date().toISOString().split('T')[0];
    },
  },
  methods: {
    close() {
      this.show = false;
      this.$refs.observer.reset();
      if (this.$refs.fileUpload) {
        this.$refs.fileUpload.removeAllItems();
      }
    },
    async SaveCategory() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.CreateExpense();
      }
    },

    getWarehouseByQuery(query = "") {
      this.warehouseLoading = true;
      this.$store
        .dispatch("warehouse/GetWarehouse", { query: query, status: "active" })
        .then((res) => {
          console.log(res);
          this.warehouses = res;
          this.warehouseLoading = false;
        })
        .catch((err) => {
          this.warehouseLoading = false;
          this.messages = err.data.name;
        });
    },
    async getAllRoom(value = "") {
      this.roomLoading = true;
      await this.$store
        .dispatch("Kitchen/GetRooms", { query: value })
        .then((res) => {
          console.log("Rooms Data Length:", res.length);
          this.rooms = res;
          this.roomLoading = false;
        })
        .catch((err) => {
          this.roomLoading = false;
        });
    },
    async getAllKitchen(value) {
      await this.$store
        .dispatch("Kitchen/GetKitchen", {})
        .then((res) => {
          this.kitchens = res;
        })
        .catch((err) => {});
    },
    getExpenseCategoriesByQuery() {
      this.expenseLoading = true;
      this.$store
        .dispatch("sitesetting/GetExpenseCategories")
        .then((res) => {
          console.log(res);
          this.expenseCategories = res.data.data;
          this.expenseLoading = false;
        })
        .catch((err) => {
          this.expenseLoading = false;
          this.messages = err.data.name;
        });
    },
    CreateExpense() {
      this.isLoading = true;
      this.$store
        .dispatch("warehouse/createExpense", {
          expense_for: this.Expense.type,
          warehouse_id: this.Expense.wareHouse_id,
          room_id: this.Expense.room_id,
          kitchen_id: this.Expense.kitchen_id,
          category_id: this.Expense.category_id,
          amount: this.Expense.amount,
          remark: this.Expense.remark,
          date: this.Expense.date,
        })
        .then(async (res) => {
          this.succeeed = true;
          this.$emit("afterSave");
          this.$toast.success("Expense created succesfully");

          if (this.selectedFiles) {
            var fileId = res.data.id;
            var files = this.selectedFiles;
            var documentType = "Invoice";
            this.$store
              .dispatch("DocumentUploads", {
                fileId,
                files,
                documentType,
              })
              .then((resp) => {
                console.log(resp);
              });
          }
          this.Expense = new Expenses();
          this.$refs.observer.reset();
          if (this.$refs.fileUpload) {
            this.$refs.fileUpload.removeAllItems();
          }
          this.isLoading = false;
          this.$emit("close");
        })
        .catch((err) => {
          this.isLoading = false;
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error("Expense created failed!");
          this.isLoading = false;
        });
    },
  },

  created() {
    this.getExpenseCategoriesByQuery();
    this.getWarehouseByQuery();
    this.getAllRoom("");
    this.getAllKitchen("");
  },
  watch: {
    searchRoom(value) {
      if (!value) {
        this.getAllRoom("");
      }
      this.getAllRoom(value);
    },
  },
};
</script>
